// src/contexts/SettingsProvider.jsx
import { createContext, useContext, useEffect, useState } from "react";

const SettingsContext = createContext();

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(() => {
    const saved = localStorage.getItem("settings");
    if (saved) return JSON.parse(saved);

    return {
      halal: false,
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC",
      disabledUntil: null,
      authEnabled: false,
      authSecret: ""
    };
  });

  useEffect(() => {
    localStorage.setItem("settings", JSON.stringify(settings));
  }, [settings]);

  // universal setter (same as your old code)
  const updateSettings = (values) => {
    setSettings((prev) => ({ ...prev, ...values }));
  };

  return (
    <SettingsContext.Provider value={{ settings, setSettings: updateSettings }}>
      {children}
    </SettingsContext.Provider>
  );
}

export function useSettings() {
  return useContext(SettingsContext);
}
